<template>
  <div id="About" :style="{width:'100%',height:height}">
    <div class="swiper-container swiperHome" style="width:100%;height:100%;z-index:-11">
      <div class="swiper-wrapper" style="height:100%">
        <div id="image" class="swiper-slide" v-for="item in img" :key="item.id">
          <img style="width:100%;height:100%" :src="item.fileUrl" alt />
          <div id="text">
            <div>
              <div id="swiperFont">
                <div>
                  <div id="borderTop"></div>
                  <div id="name">医院院训</div>
                  <div id="borderBottom"></div>
                </div>
              </div>
              <div id="swiperDetail1">
                <div style="writing-mode: tb-rl;" @click="open">精诚济世</div>
              </div>
              <div id="swiperDetail">
                <div style="writing-mode: tb-rl;" @click="open">仁慈博爱</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="about">
      <transition name="el-fade-in-linear">
        <div v-show="show" id="survey" @click="open('/medicine')">
          <img id="surverImg" src="../assets/img/fu.png" alt />
          <img id="surverImg1" src="../assets/img/fu.png" alt />
          <div style="margin-top:15px">健康苗医</div>
        </div>
      </transition>
      <transition name="el-zoom-in-center">
        <div v-show="show" id="survey1" @click="open('/Survey')">
          <img id="surverImg" src="../assets/img/fu.png" alt />
          <img id="surverImg1" src="../assets/img/fu.png" alt />
          <div style="margin-top:15px">医院概况</div>
        </div>
      </transition>
      <transition name="el-zoom-in-top">
        <div v-show="show" id="survey2" @click="open('/doctor')">
          <img id="surverImg" src="../assets/img/fu.png" alt />
          <img id="surverImg1" src="../assets/img/fu.png" alt />
          <div style="margin-top:15px">专家介绍</div>
        </div>
      </transition>
      <transition name="el-zoom-in-bottom">
        <div v-show="show" id="survey3" @click="open('/administrative')">
          <img id="surverImg" src="../assets/img/fu.png" alt />
          <img id="surverImg1" src="../assets/img/fu.png" alt />
          <div style="margin-top:15px">科室导航</div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "../../node_modules/swiper/css/swiper.css";
export default {
  data() {
    return {
      sectionList: "",
      show: false,
      img: [],
      height: ""
    };
  },
  methods: {
    open(url) {
      this.$router.push({ path: url });
    },
    shows() {
      setTimeout(() => {
        this.show = true;
        this.img = this.$store.getters.img;
      }, 1000);
    }
  },
  created() {
    this.shows();

    // console.log(this.img)
  },
  mounted() {
    var mySwiper = new Swiper(".swiperHome", {
      autoplay: false, //可选选项，自动滑动
      loop: true
    });
    // console.log(window.screen.height)
    if (window.screen.height == 1080) {
      this.height = "70%";
    } else if (window.screen.height == 1050) {
      this.height = "70%";
    } else {
      this.height = "70%";
    }
    console.log(this.height);
  }
};
</script>
<style lang="less" scoped>
#About {
  width: 100%;
  // height: calc(100% - 284px)!important;
  // background-image: url(../assets/img/bg.png);
  // background-size: 100% 100%;
  #image {
    position: relative;
  }
  #text {
    position: absolute;
    right: -30px;
    top: 2vh;
    font-family: MyFont;
    color: #0373A7;
    #swiperFont {
      position: absolute;
      right: 300px;
      top: 50px;
      #name {
        font-size: 46px;
        width: 40px;
        padding: 20px;
        text-align: center;
        position: absolute;
        top: 25px;
      }
      #borderTop {
        width: 80px;
        height: 100px;
        position: absolute;
        background-image: url(../assets/img/png3_03.png);
        background-size: 100% 100%;
      }
      #borderBottom {
        width: 80px;
        height: 100px;
        position: absolute;
        top: 180px;
        background-image: url(../assets/img/png4_03.png);
        background-size: 100% 100%;
      }
    }

    #swiperText {
      position: absolute;
      right: 350px;
      // height: 80%;
      top: 40px;
      writing-mode: tb-rl;
    }

    #swiperDetail :hover {
      cursor: pointer;
    }

    #swiperDetail {
      position: absolute;
      right: 380px;
      top: 45px;
      font-size: 34px;
      padding: 10px;
      font-family: MyFont;
    }
    #swiperDetail1 {
      position: absolute;
      right: 320px;
      top: 150px;
      font-size: 34px;
      padding: 10px;
      font-family: MyFont;
    }
  }
  #bg {
    height: 100%;
    width: 100%;
    min-width: 1300px;
    position: absolute;
    left: 0;
    top: 130px;
  }
  @font-face {
    font-family: "MyFont1";
    src: url(../assets/font/sbxs.ttf);
  }
  .about {
    font-family: Myfont1;
    font-size: 61px;
    background-repeat: no-repeat;
    background-size: 100% 99.9%;
    color: white;
    position: absolute;
    top: 30vh;
    left: 50px;
    width: 800px;
    // height: 100%;
  }
  #survey,
  #survey1,
  #survey2,
  #survey3 {
    background-color: #0574a8;
    width: 160px;
    height: 160px;
    position: absolute;
    border-radius: 7px;
    overflow: hidden;
    text-align: center;
  }
  #survey2,
  #survey3 {
    // background-color: rgba(228, 222, 218, 0.95);
  }
  #survey {
    left: 25%;
    top: 90px;
  }
  #survey1 {
    left: 20px;
    top: 240px;
  }
  #survey2 {
    left: 25%;
    top: 280px;
  }
  #survey3 {
    left: 48%;
    top: 180px;
  }
  #surverImg {
    position: absolute;
    width: 70px;
    height: 70px;
    left: 140px;
    top: -30px;
  }
  #surverImg1 {
    position: absolute;
    width: 100px;
    height: 100px;
    left: -10px;
    bottom: -40px;
  }
}
</style>
<style lang="less">
@media screen and (max-width: 1440px) {
  #About {
  }
}
@media screen and (max-width: 1360px) {
  #About {
    .about {
      // left: 50px !important;
    }
  }
}
</style>
